import React from 'react'
import * as UI from 'ui'
import { Link } from '@morningtrain/react-navigation'

export default function BackToOverview ({ route, children }) {
  return (
    <Link route={route}>
      <UI.Button color='outlineDark'>
        <UI.WithIcon size={5} placement='left' icon={<UI.Icons.ArrowLeft />}>
          {children}
        </UI.WithIcon>
      </UI.Button>
    </Link>
  )
}
